var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Calendar',{ref:"calendar",attrs:{"eventCategories":_vm.eventCategories,"events":_vm.events,"monthNames":_vm.monthNames,"weekdaysNames":_vm.weekdaysNames,"firstDayOfWeek":2},on:{"nextMonthEvent":_vm.nextMonthEvent,"prevMonthEvent":_vm.prevMonthEvent,"selectedDateEvent":_vm.selectedDateEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }